<template>
    <div class="imgRowWrapper message-wrapper">
        <div v-for="picture in message.pictures" class="imgAboveWrapper">
            <img class="rowImg" v-bind:class="[wideImage ? 'wideImage' : 'tallImage']" :src="$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + picture.noticePictureId + '&type=' + picture.type" />
        </div>
        <div class="imgAboveTextWrapper">
            <p :style="[{fontSize : fontSize + 'px'}, {color : messageColour}, $kmsTheme ? $kmsTheme.styles.messageText : null]" :id="message.noticeMessageId" class="resize">
                <template v-if="message.messageTitle">
                    <span :style="[{color:message.messageTitleColour}, message.messageTitleFont ? {'font-family':message.messageTitleFont} : null]">{{message.messageTitle}}</span>
                    <br />
                </template>
                <span :style="[message.messageFont ? {'font-family':message.messageFont} : null]">
                    {{message.message}}
                </span>
            </p>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import messageMixin from './../../mixins/text-message'

    export default {
        mixins: [messageMixin],
        created() {
            this.parentClass = ".imgAboveTextWrapper";
        }
    }



</script>
<style>
    .imgAboveWrapper {
        height: calc(50% - 1rem);
        width: 100%;
        margin-bottom: 1rem;
        clear: both;
        text-align: center
    }

    .imgAboveTextWrapper {
        width: 100%;
        height: calc(50% - 1rem);
        margin-bottom: 1rem;
        clear: both;
        text-align: center;
    }
</style>
